module.exports = __webpack_public_path__ + "img/Pl3.6797c441.png";